import { RootState } from '../../reduxStore/store';
import { createSelector } from 'reselect';
import { FundMarketNewsState } from './fundMarketNewsSlice';
import { INewsItemType } from '../../types';
import { v4 as uuidv4 } from 'uuid';
import { sortByVisibleDate } from '../../utils/utils';
import { isAfter, isBefore, parseISO } from 'date-fns';

const fundMarketNewsDomain = (state: RootState): FundMarketNewsState => {
  return state?.fundMarketNews;
};
const setId = (data: INewsItemType[]) => {
  return data?.map((item) => ({
    ...item,
    id: uuidv4()
  }));
};

const makeFundMarketNewsList = () =>
  createSelector(fundMarketNewsDomain, (subState) => {
    const filteredData = [...setId(subState.fundMarketNewsList)].filter(
      (item) => item.action_type !== ''
    );

    return sortByVisibleDate(filteredData);
  });

const makeLastTwelveMonthsFundMarketNewsList = () =>
  createSelector(makeFundMarketNewsList(), (allNews) => {
    const now = new Date();
    const twelveMonthsAgo = new Date(
      now.getFullYear(),
      now.getMonth() - 12,
      now.getDate()
    );

    return allNews.filter((item) => {
      const itemDate = parseISO(item.visible_date);
      return isAfter(itemDate, twelveMonthsAgo) && isBefore(itemDate, now);
    });
  });

export { makeFundMarketNewsList, makeLastTwelveMonthsFundMarketNewsList };
